import mediaAPI from '../../../api/media'

const mapOrder = (order) => {
  switch (order) {
  case 'name':
    return 'name'
  case 'created':
    return 'created_at'
  case 'size':
    return 'size'
  default:
    return 'created_at'
  }
}

export default {
  async index({commit, rootState, state}, view) {
    const tenantID = rootState.tenants.current.id
    const meta = state.views[view].meta

    const params = {tenantID}

    if (typeof(meta.module) !== 'undefined' && meta.module !== null) {
      params.module = meta.module
    }
    if (typeof(meta.type) !== 'undefined' && meta.type !== null) {
      params.type = meta.type
    }
    if (typeof(meta.module) !== 'undefined' && meta.module !== null) {
      params.module = meta.module
    }
    if (typeof(meta.order) !== 'undefined' && meta.order !== null) {
      params.order = mapOrder(meta.order)
    }
    if (typeof(meta.desc) !== 'undefined' && meta.desc !== null) {
      params.desc = meta.desc
    }
    if (typeof(meta.search) !== 'undefined' && meta.search !== null) {
      params.search = meta.search
    }
    if (typeof(meta.current_page) !== 'undefined' && meta.current_page !== null) {
      params.page = meta.current_page
    }

    commit('setFetchingForView', {view, value: true})

    const resp = await mediaAPI.index(params)
    const index = resp.data.data
    const updatedMeta = resp.data.meta

    commit('setView', {view, index, meta: updatedMeta})
    commit('setFetchingForView', {view, value: false})
  },

  async show({commit, rootState}, {id}) {
    const tenantID = rootState.tenants.current.id
    const resp = await mediaAPI.show({tenantID, mediaID: id})
    commit('setCurrent', resp.data.data)
  },

  async store({commit, state, dispatch, rootState}) {
    const tenantID = rootState.tenants.current.id

    const formData = new FormData()
    formData.append('name', state.forms.store.fields.name)
    formData.append('file', state.forms.store.fields.file)
    if (state.forms.store.fields.thumbnail) {
      formData.append('thumbnail', state.forms.store.fields.thumbnail)
    }

    // add any module relations
    let moduleData
    if (state.forms.relateModules.fields.moduleIDs !== null) {
      moduleData = {'modules': state.forms.relateModules.fields.moduleIDs}
    }

    commit('forms/store/resetErrors')
    commit('forms/store/resetSuccess')
    commit('forms/store/setSaving', true)

    let newMedia, resp
    let success = true

    try {
      // store the media
      resp = await mediaAPI.store({tenantID, data: formData})
      newMedia = resp.data.data

      // add any module relations
      if (moduleData) {
        await mediaAPI.relateModules({tenantID, mediaID: newMedia.id, data: moduleData})
        resp = await mediaAPI.show({tenantID, mediaID: newMedia.id})
        newMedia = resp.data.data
      }

    } catch (err) {
      success = false

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/store/setErrors', errors)
        }
      }
    }

    commit('forms/store/setSaving', false)
    commit('forms/store/setSuccess', success)

    if (success) {
      dispatch('index', state._defaultView)
    }
  },

  async update({commit, state, rootState, dispatch}, {media}) {
    const tenantID = rootState.tenants.current.id

    const formData = new FormData()
    if (state.forms.update.fields.name) {
      formData.append('name', state.forms.update.fields.name)
    }

    if (state.forms.update.fields.file) {
      formData.append('file', state.forms.update.fields.file)
    }

    if (state.forms.update.fields.thumbnail) {
      formData.append('thumbnail', state.forms.update.fields.thumbnail)
    }

    // add any module relations
    let moduleData
    if (state.forms.relateModules.fields.moduleIDs !== null) {
      moduleData = {'modules': state.forms.relateModules.fields.moduleIDs}
    }

    commit('forms/update/resetErrors')
    commit('forms/update/resetSuccess')
    commit('forms/update/setSaving', true)

    let resp, updatedMedia
    let success = true

    try {
      // update the media
      resp = await mediaAPI.update({tenantID, mediaID: media.id, data: formData})
      updatedMedia = resp.data.data

      // add any module relations
      if (moduleData) {
        await mediaAPI.relateModules({tenantID, mediaID: updatedMedia.id, data: moduleData})
        resp = await mediaAPI.show({tenantID, mediaID: updatedMedia.id})
        updatedMedia = resp.data.data
      }

    } catch (err) {
      success = false

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/update/setErrors', errors)
        }
      }
    }

    commit('forms/update/setSaving', false)
    commit('forms/update/setSuccess', success)

    if (success) {
      commit('setCurrent', updatedMedia)
      dispatch('index', state._defaultView)
    }
  },

  async destroy({commit, state, rootState, dispatch}, {mediaID}) {
    const tenantID = rootState.tenants.current.id
    commit('setFetchingForView', {view: state._defaultView, value: true})
    await mediaAPI.destroy({tenantID, mediaID})
    dispatch('index', state._defaultView)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/media/actions.js